/* eslint-disable */
import moment from 'moment';

// DON'T CHANGE THE IMPORT ORDER!
// Since all imports are hoisted and importing a new moment locale
// automatically sets the global moment instance to that locale, we
// need to import the current moment locale from another file
// to ensure it is preserved before importing the other supported locales
import currentLanguage from './getCurrentMomentLocale';

import 'moment/locale/de';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/nb';
import 'moment/locale/nl';
import 'moment/locale/sv';

moment.locale(currentLanguage);
